module.exports = __webpack_public_path__ + "img/82.c6202caf.jpg";